// extracted by mini-css-extract-plugin
export default {"wrapper":"SlideWrapper_wrapper__PxhKl","slider":"SlideWrapper_slider__ZA7qd","arrowNext":"SlideWrapper_arrowNext__3HHHu","arrowPrev":"SlideWrapper_arrowPrev__lsEDY"};